export const kebabCase = (str?: string) =>
    (str || "")
        .replace(/[^a-zA-Z0-9\s]/g, "")
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/\s+/g, "-")
        .toLowerCase();
